<template>
  <div class="ms-container">
    <bgs-page />
  </div>
</template>

<script>
import BgsPage from '@/components/bgs/bgs-page'

export default {
  components: {
    BgsPage
  }
}
</script>

<style></style>
